import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  Event,
} from '@angular/router';
// Ejecutar del lado del servidor o del lado del cliente
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private location: Location,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this._platformId)) {
      // Client side code.
      // this.checkRouteChange();
    }
    if (isPlatformServer(this._platformId)) {
      // Server side code.
      // https://github.com/angular/universal#universal-gotchas
    }
  }

  ngOnInit() {
    // this.initTawkTo();
  }

  /**
   * Función para llamar el script de tawk.to
   * https://stackoverflow.com/questions/56072210/angular-2-4-5-6-adding-tawk-widget-to-specific-pages-in-angular-6
   */
  initTawkTo() {
    // load script for tawk widget
    // this.script
    //   .load('tawk')
    //   .then((data) => {
    //     console.log('script loaded', data);
    //   })
    //   .catch((error) => console.log(error));
  }

  /**
   * Chequeo de cambio de ruta que servirá para el cambio de nombre de la pestaña
   * https://stackoverflow.com/questions/33520043/how-to-detect-a-route-change-in-angular
   */
  checkRouteChange() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
      }
      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        if (this.location.path().includes('dashboard')) {
          this.unmountTawkToChat();
        } else {
          this.initTawkTo();
        }
      }
      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });
  }

  /**
   * Remover TawkTo del HTML
   */
  public unmountTawkToChat() {
    const head = <HTMLDivElement>document.head;
    const body = <HTMLDivElement>document.body;

    const tawkToScript = document.getElementById('TawkToSupportChat');
    const chatInstance = document.getElementById('TawkToInterface');
    // console.log(tawkToScript);
    // console.log(chatInstance);
    if (tawkToScript != null && chatInstance != null) {
      head.removeChild(tawkToScript);
      head.removeChild(chatInstance);
    }

    body.childNodes.forEach((child) => {
      // console.log(child.nodeName);
      if (child.nodeName === 'DIV') {
        child.remove();
      } else {
        return;
      }
    });
  }
}
